import React from 'react';
import '../../styles/stylesForShared/loader.scss';

function Loader() {
    return (
        <div className='loader-frame'>
            <div className='loader-spinner' />
        </div>
    );
}


export default Loader;
